interface StatisticsCardsProps {
  totalCount: number;
  runningCount: number;
  todayNewCount: number;
  expiringSoonCount: number;
}

export default function StatisticsCards({
  totalCount,
  runningCount,
  todayNewCount,
  expiringSoonCount,
}: StatisticsCardsProps) {
  const cards = [
    {
      title: '实例总数',
      value: totalCount,
      icon: 'ri-server-line',
      color: 'bg-blue-500',
    },
    {
      title: '运行中实例数',
      value: runningCount,
      icon: 'ri-play-circle-line',
      color: 'bg-green-500',
    },
    {
      title: '今日新增实例',
      value: todayNewCount,
      icon: 'ri-add-circle-line',
      color: 'bg-purple-500',
    },
    {
      title: '即将到期实例',
      value: expiringSoonCount,
      icon: 'ri-time-line',
      color: 'bg-orange-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards.map((card) => (
        <div
          key={card.title}
          className="bg-white rounded-lg p-6 shadow-sm border border-gray-200"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">{card.title}</p>
              <p className="text-3xl font-bold text-gray-900">{card.value}</p>
            </div>
            <div
              className={`w-12 h-12 ${card.color} rounded-lg flex items-center justify-center`}
            >
              <i className={`${card.icon} text-2xl text-white`}></i>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
